module.exports = __webpack_public_path__ + "static/img/xgboost.fe96b31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xgboost.png
// module id = p9sJ
// module chunks = 1